import axios from 'axios';
import {
    GET_HARYANA_RECORDS_REQUEST,
    GET_HARYANA_RECORDS_SUCCESS,
    GET_HARYANA_RECORDS_FAIL,
    GET_HARYANA_RECORDS_RESET,
    CREATE_HARYANA_RECORD_REQUEST,
    CREATE_HARYANA_RECORD_SUCCESS,
    CREATE_HARYANA_RECORD_FAIL,
    CREATE_HARYANA_RECORD_RESET,
    UPDATE_HARYANA_RECORD_REQUEST,
    UPDATE_HARYANA_RECORD_SUCCESS,
    UPDATE_HARYANA_RECORD_FAIL,
    UPDATE_HARYANA_RECORD_RESET,
    DELETE_HARYANA_RECORD_REQUEST,
    DELETE_HARYANA_RECORD_SUCCESS,
    DELETE_HARYANA_RECORD_FAIL,
    DELETE_HARYANA_RECORD_RESET,
    IMPORT_HARYANA_RECORDS_REQUEST,
    BULK_DELETE_HARYANA_RECORDS_REQUEST,    // ← Add this
    BULK_DELETE_HARYANA_RECORDS_SUCCESS,    // ← Add this
    BULK_DELETE_HARYANA_RECORDS_FAIL,
    IMPORT_HARYANA_RECORDS_SUCCESS,
    IMPORT_HARYANA_RECORDS_FAIL,
    IMPORT_HARYANA_RECORDS_RESET,
    EXPORT_HARYANA_RECORDS_REQUEST,
    EXPORT_HARYANA_RECORDS_SUCCESS,
    EXPORT_HARYANA_RECORDS_FAIL,
    EXPORT_HARYANA_RECORDS_RESET,
} from '../constants/harayanaConstants';
import { logout } from './userActions';

const baseUrl = process.env.REACT_APP_API_URL;

// Get all Haryana records with pagination and search
export const getHaryanaRecords = (queryParams = '') => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_HARYANA_RECORDS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        // Parse and validate query parameters
        const params = new URLSearchParams(queryParams);
        const page = Math.max(1, parseInt(params.get('page')) || 1);
        const limit = Math.max(1, parseInt(params.get('limit')) || 10);
        const search = params.get('search') || '';
        const importDate = params.get('importDate') || '';
        const status = params.get('status') || '';
        const typeFilter = params.get('typeFilter') || '';
        const departmentFilter = params.get('departmentFilter') || '';
        const fosFilter = params.get('fosFilter') || '';

        // Rebuild clean query string
        let cleanQuery = `search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`;
        if (importDate) {
            cleanQuery += `&importDate=${encodeURIComponent(importDate)}`;
        }
        if (status) {
            cleanQuery += `&status=${encodeURIComponent(status)}`;
        }
        if (typeFilter) {
            cleanQuery += `&typeFilter=${encodeURIComponent(typeFilter)}`;
        }
        if (departmentFilter) {
            cleanQuery += `&departmentFilter=${encodeURIComponent(departmentFilter)}`;
        }
        if (fosFilter) {
            cleanQuery += `&fosFilter=${encodeURIComponent(fosFilter)}`;
        }

        console.log('API Call with params:', { search, page, limit, importDate, status, typeFilter, departmentFilter, fosFilter });

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/haryana?${cleanQuery}`,
            config
        );

        dispatch({
            type: GET_HARYANA_RECORDS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: GET_HARYANA_RECORDS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

// Create new Haryana record
export const createHaryanaRecord = (recordData) => async (dispatch, getState) => {
    try {
        dispatch({
            type: CREATE_HARYANA_RECORD_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `${baseUrl}/haryana`,
            recordData,
            config
        );

        dispatch({
            type: CREATE_HARYANA_RECORD_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: CREATE_HARYANA_RECORD_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

// Update Haryana record
export const updateHaryanaRecord = (id, recordData) => async (dispatch, getState) => {
    try {
        dispatch({
            type: UPDATE_HARYANA_RECORD_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.put(
            `${baseUrl}/haryana/${id}`,
            recordData,
            config
        );

        dispatch({
            type: UPDATE_HARYANA_RECORD_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: UPDATE_HARYANA_RECORD_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

// Delete Haryana record
export const deleteHaryanaRecord = (id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: DELETE_HARYANA_RECORD_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        await axios.delete(`${baseUrl}/haryana/${id}`, config);

        dispatch({
            type: DELETE_HARYANA_RECORD_SUCCESS,
            payload: id,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: DELETE_HARYANA_RECORD_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

// Import Haryana records from file
export const importHaryanaRecords = (formData) => async (dispatch, getState) => {
    try {
        dispatch({
            type: IMPORT_HARYANA_RECORDS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `${baseUrl}/haryana/import`,
            formData,
            config
        );

        dispatch({
            type: IMPORT_HARYANA_RECORDS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: IMPORT_HARYANA_RECORDS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

// Export Haryana records to file
export const exportHaryanaRecords = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: EXPORT_HARYANA_RECORDS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`,
            },
            responseType: 'blob',
        };

        const { data } = await axios.get(
            `${baseUrl}/haryana/export`,
            config
        );

        // Create download link
        const url = URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Haryana_Export.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);

        dispatch({
            type: EXPORT_HARYANA_RECORDS_SUCCESS,
            payload: 'Export completed successfully',
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: EXPORT_HARYANA_RECORDS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};
// Add this missing action to haryanaActions.js (after exportHaryanaRecords):

// Bulk delete Haryana records
export const bulkDeleteHaryanaRecords = (ids) => async (dispatch, getState) => {
    try {
        dispatch({
            type: BULK_DELETE_HARYANA_RECORDS_REQUEST,  // ← Use proper constant
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `${baseUrl}/haryana/bulk-delete`,
            { ids },
            config
        );

        dispatch({
            type: BULK_DELETE_HARYANA_RECORDS_SUCCESS,  // ← Use proper constant
            payload: { ids, deletedCount: data.deletedCount },
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: BULK_DELETE_HARYANA_RECORDS_FAIL,     // ← Use proper constant
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const syncHaryanaTaskStatus = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: 'SYNC_HARYANA_TASK_STATUS_REQUEST',
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        const { data } = await axios.post(
            `${baseUrl}/haryana/sync-status`,
            {},
            config
        );

        dispatch({
            type: 'SYNC_HARYANA_TASK_STATUS_SUCCESS',
            payload: data,
        });

        return data; // Return data including updatedRecords
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: 'SYNC_HARYANA_TASK_STATUS_FAIL',
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw error;
    }
};

export const getFieldExecutives = (search = '') => async (dispatch, getState) => {
    try {
        dispatch({
            type: 'GET_FIELD_EXECUTIVES_REQUEST',
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/haryana/field-executives?search=${encodeURIComponent(search)}`,
            config
        );

        dispatch({
            type: 'GET_FIELD_EXECUTIVES_SUCCESS',
            payload: data,
        });

        return data; // Return the data
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: 'GET_FIELD_EXECUTIVES_FAIL',
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw error; // Throw error so it can be caught
    }
};

export const getHaryanaDepartments = (importDate = '') => async (dispatch, getState) => {
    try {
        dispatch({
            type: 'GET_DEPARTMENTS_REQUEST',
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        let url = `${baseUrl}/haryana/departments`;
        if (importDate) {
            url += `?importDate=${encodeURIComponent(importDate)}`;
        }

        const { data } = await axios.get(url, config);

        dispatch({
            type: 'GET_DEPARTMENTS_SUCCESS',
            payload: data,
        });

        return data;
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: 'GET_DEPARTMENTS_FAIL',
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw error;
    }
};

export const getHaryanaFOS = (importDate = '') => async (dispatch, getState) => {
    try {
        dispatch({
            type: 'GET_FOS_REQUEST',
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo?.token}`,
            },
        };

        let url = `${baseUrl}/haryana/fos`;
        if (importDate) {
            url += `?importDate=${encodeURIComponent(importDate)}`;
        }

        const { data } = await axios.get(url, config);

        dispatch({
            type: 'GET_FOS_SUCCESS',
            payload: data,
        });

        return data;
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: 'GET_FOS_FAIL',
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
        throw error;
    }
};
